/* eslint-disable react/no-array-index-key */
import React from 'react';
import Loading from 'react-loading';
import styled from 'styled-components';
import { Table } from '../../components/elements';

const Center = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const DrilldownTable = ({ drilldownTableData, loading }) => (
  <div style={{ padding: '10px' }}>
    <Table>
      <thead>
        <tr>
          {[
            'Venue',
            'Sales Rep',
            'All Orders',
            'All Sales',
            'App Fees',
            'Payout',
            'Misd Order',
            'Draft Order',
            'Avg Order',
            'Total Gst',
            'P Gst',
            'K Gst',

            'Delivery',
            'Sales',
            'Total Gst',
            'P Gst',
            'K Gst',

            'Dinein',
            'Sales',
            'Total Gst',
            'P Gst',
            'K Gst',

            'Pickup',
            'Sales',
            'Total Gst',
            'P Gst',
            'K Gst',

            'Del Fees',
            'Srv Fees',
            'K Fees',
            'F Fees',
            'GST',
            'Kravein Payment Gateway Fees',
          ].map((headerCellValue, index) => (
            <th style={{ fontWeight: 700 }} key={`${headerCellValue}-${index}`}>
              <div>
                <span>{headerCellValue}</span>
              </div>
            </th>
          ))}
        </tr>
      </thead>

      {!loading && drilldownTableData && (
        <tbody>
          {drilldownTableData.map((ddValue, index) => (
            <tr style={{ fontWeight: 600 }} key={`${ddValue.venue}-${index}`}>
              <td style={{ color: '#00AEEF', whiteSpace: 'nowrap' }}>
                {ddValue.venue}
              </td>
              <td>{ddValue.salesRep || '-'}</td>
              <td>{ddValue.allOrders}</td>
              <td>{ddValue.allSales}</td>
              <td>{ddValue.appfee}</td>
              <td>{ddValue.payout}</td>
              <td>{ddValue.missedOrders}</td>
              <td>{ddValue.drafts}</td>
              <td>{ddValue.averageSales}</td>

              <td>{ddValue.totalGst}</td>
              <td>{ddValue.pGst}</td>
              <td>{ddValue.kGst}</td>

              <td>{ddValue.deliveryTotalOrders}</td>
              <td>{ddValue.deliverySales}</td>
              <td>{ddValue.deliveryTotalGst}</td>
              <td>{ddValue.deliveryPGst}</td>
              <td>{ddValue.deliveryKGst}</td>

              <td>{ddValue.dineinTotalOrders}</td>
              <td>{ddValue.dineinSales}</td>
              <td>{ddValue.dineinTotalGst}</td>
              <td>{ddValue.dineinPGst}</td>
              <td>{ddValue.dineinKGst}</td>

              <td>{ddValue.pickupTotalOrders}</td>
              <td>{ddValue.pickupSales}</td>
              <td>{ddValue.pickupTotalGst}</td>
              <td>{ddValue.pickupPGst}</td>
              <td>{ddValue.pickupKGst}</td>

              <td>{ddValue.delFees}</td>
              <td>{ddValue.srvfee}</td>
              <td>{ddValue.kFees}</td>
              <td>{ddValue.fFees}</td>
              <td>{ddValue.gst}</td>
              <td>{ddValue.paymentGatewayFee}</td>
            </tr>
          ))}
        </tbody>
      )}
    </Table>
    {loading && (
      <Center>
        <Loading type="spin" color="#363636" width="60px" height="60px" />
      </Center>
    )}
  </div>
);

export default DrilldownTable;
